/* eslint-disable react/jsx-filename-extension */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import SelectTemplate from '../Template/SelectTemplate';

class TemplatedMsgSelectionDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTemplates: false,
    };
  }

  onSelectedTemplate = templateId => {
    const { templatedMsgs, handleTemplatedMsgSelection } = this.props;
    const newSelTemplate = templatedMsgs.find(
      tm => tm.templatedMsg.id === templateId
    );

    if (newSelTemplate) {
      handleTemplatedMsgSelection(newSelTemplate);
    }
    this.onShowTemplates();
  };

  onShowTemplates = () => {
    this.setState(state => ({
      ...state,
      showTemplates: !state.showTemplates,
    }));
  };

  render() {
    const arrActionBtns = [];
    const {
      selectedTemplate,
      templatedMsgs,
      open,
      handleOk,
      requestResumeChat,
    } = this.props;
    const { showTemplates } = this.state;

    if (requestResumeChat) {
      arrActionBtns.push(
        <Button onClick={requestResumeChat} color="primary" variant="contained">
          <FormattedMessage id="AgentToolbar.resumeButtonLbl" />
        </Button>
      );
      arrActionBtns.push(
        <Button onClick={handleOk} color="primary" variant="outlined">
          <FormattedMessage id="General.cancel" />
        </Button>
      );
    } else {
      arrActionBtns.push(
        <Button onClick={handleOk} color="primary" variant="contained">
          Ok
        </Button>
      );
    }

    return (
      <Dialog
        open={open}
        handleClose={this.handleClose}
        actions={arrActionBtns}
      >
        <DialogTitle>
          <FormattedMessage id="TemplatedMsg.selectTemplateTitle" />
        </DialogTitle>
        <DialogContent>
          <SelectTemplate
            onSelectedTemplate={this.onSelectedTemplate}
            selectedTemplate={selectedTemplate}
            templatedMsgs={templatedMsgs}
            showTemplates={showTemplates}
            onShowTemplates={this.onShowTemplates}
          />
        </DialogContent>
        <DialogActions>{arrActionBtns}</DialogActions>
      </Dialog>
    );
  }
}

export default injectIntl(TemplatedMsgSelectionDialog);
